import React from 'react';

import './spinner.css';

export default function Spinner({ ...props }) {
  return <div {...props} className="loader w-full h-full"></div>;
}
